



































import Vue from 'vue';
import PaymentsService from '@/services/PaymentsService';
import RouteNames from '@/router/RouteNames';

export default Vue.extend({
  name: 'PayPalPaymentResult',
  data() {
    return {
      orderId: null as number | null,
      action: '' as string,
      target: '' as string,
      status: 'loading' as 'loading' | 'success' | 'failed' | 'cancel',
      loading: true,
      pollingInterval: null as any,
    };
  },
  computed: {
    targetLink(): any {
      // Currently all targets lead to subscriptions
      return { name: RouteNames.MY_SUBSCRIPTIONS };
    }
  },
  async created() {
    this.orderId = Number(this.$route.query.oid);
    this.action = this.$route.query.action as string;
    this.target = this.$route.query.target as string;

    if (this.action === 'cancel') {
      this.status = 'cancel';
      this.loading = false;
      return;
    }

    if (this.action === 'success') {
      this.startPolling();
    } else {
      this.status = 'failed';
      this.loading = false;
    }
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    startPolling() {
      this.checkStatus();
      this.pollingInterval = setInterval(this.checkStatus, 10000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    async checkStatus() {
      if (!this.orderId) return;

      try {
          const response = await PaymentsService.getPayPalOrderShort(this.orderId);
          const data = response.data;

          // Check if everything is COMPLETED/PAID
          const isOrderCompleted = data.orderStatus === 'COMPLETED' || data.orderStatus === 'APPROVED' || data.orderStatus === 'CAPTURED';
          const isCaptureCompleted = data.captureStatus === 'COMPLETED';
          const isTargetPaid = data.targetStatus === 'PAID' || data.targetStatus === 'COMPLETED';

          if (isOrderCompleted && isCaptureCompleted && isTargetPaid) {
            this.status = 'success';
            this.loading = false;
            this.stopPolling();
          } else if (data.captureStatus === 'DECLINED' || data.captureStatus === 'FAILED' || data.targetStatus === 'FAILED') {
            this.status = 'failed';
            this.loading = false;
            this.stopPolling();
          }
      } catch (error) {
        console.error('Failed to poll payment status', error);
      }
    }
  }
});
